module.exports = __webpack_public_path__ + "static/media/341.0d44ae39.webp";